"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataHooks = void 0;
function dataHooks(componentName) {
    // @ts-expect-error we set handler on an empty object
    return new Proxy({}, handler(componentName));
}
exports.dataHooks = dataHooks;
function handler(componentName) {
    return {
        get(obj, element) {
            return (options) => buildDataHook(componentName, element, options);
        },
    };
}
function buildDataHook(cmp, element, options) {
    const strOptions = buildOptions(options).map((optionWithValue) => `${element}--${optionWithValue}`);
    return [`${cmp}__${element}`, ...strOptions].join(' ');
}
function buildOptions(options) {
    return Object.entries(options || {})
        .map(([key, value]) => {
        if (typeof value === 'boolean' || value === null || value === undefined) {
            return value ? key : '';
        }
        return `${key}_${value}`;
    })
        .filter(Boolean);
}
//# sourceMappingURL=dataHooks.js.map